import React__default from 'react';
import classNames from './../../external_lib/classnames/index.js';
import Cancel from '../../assets/icons/jsx/Cancel.js';
import ArrowRight from '../../assets/icons/jsx/ArrowRight.js';
import Info from '../../assets/icons/jsx/Info.js';
import Alert from '../../assets/icons/jsx/Alert.js';
import ErrorAlert from '../../assets/icons/jsx/ErrorAlert.js';
import Success from '../../assets/icons/jsx/Success.js';
import HorizonText, { TextVariant } from '../HorizonText/index.js';
import styles from '../../components/base/HorizonBanner/index.module.scss.js';
var statusConfig = {
  success: {
    borderColor: 'border-up-green-50',
    bgColor: 'bg-up-green-5',
    icon: React__default.createElement(Success, {
      className: "text-up-green-50"
    })
  },
  error: {
    borderColor: 'border-up-red-50',
    bgColor: 'bg-up-red-5',
    icon: React__default.createElement(ErrorAlert, {
      className: "text-up-red-50"
    })
  },
  info: {
    borderColor: 'border-up-blue-40',
    bgColor: 'bg-up-blue-5',
    icon: React__default.createElement(Info, {
      className: "text-up-blue-40"
    })
  },
  warning: {
    borderColor: 'border-up-yellow-20',
    bgColor: 'bg-up-yellow-10',
    icon: React__default.createElement(Alert, {
      className: "text-up-yellow-20"
    })
  }
};
function HorizonBanner(_a) {
  var bannerText = _a.bannerText,
    _b = _a.bannerTextVariant,
    bannerTextVariant = _b === void 0 ? TextVariant.BODY2 : _b,
    _c = _a.headingClass,
    headingClass = _c === void 0 ? '' : _c,
    bannerHeading = _a.bannerHeading,
    _d = _a.bannerHeadingVariant,
    bannerHeadingVariant = _d === void 0 ? TextVariant.HEADING4 : _d,
    _e = _a.textClass,
    textClass = _e === void 0 ? '' : _e,
    onClose = _a.onClose,
    actionText = _a.actionText,
    onAction = _a.onAction,
    _f = _a.status,
    status = _f === void 0 ? 'info' : _f,
    icon = _a.icon,
    className = _a.className,
    _g = _a.children,
    children = _g === void 0 ? null : _g;
  return React__default.createElement("div", {
    className: classNames('rounded-sm w-full py-4 px-5 flex justify-between gap-3 border-l-[6px]', statusConfig[status].bgColor, statusConfig[status].borderColor, className),
    style: {
      borderLeftStyle: 'solid'
    }
  }, React__default.createElement("div", null, icon || statusConfig[status].icon), React__default.createElement("div", {
    className: "flex-auto"
  }, React__default.createElement("div", null, bannerHeading && React__default.createElement(HorizonText, {
    variant: bannerHeadingVariant,
    className: classNames('mb-1', headingClass)
  }, bannerHeading), bannerText && React__default.createElement(HorizonText, {
    variant: bannerTextVariant,
    className: classNames('text-up-black-60', textClass)
  }, bannerText), actionText && React__default.createElement("div", {
    className: classNames(bannerHeading && bannerText ? 'mt-4' : ['my-[-4px]', styles.actionBtnBlock] // Reduces the space between link button and above text
    )
  }, React__default.createElement(HorizonText, {
    onClick: onAction,
    variant: TextVariant.BUTTON_LINK_MEDIUM,
    className: "cursor-pointer text-up-blue-40"
  }, actionText, " ", React__default.createElement(ArrowRight, {
    className: "ml-1 w-6 h-6 mt-1.5"
  }))), children)), onClose && React__default.createElement(Cancel, {
    role: "button",
    tabIndex: 0,
    "aria-label": "Close Banner",
    className: "w-4 h-4 cursor-pointer text-up-black-50 box-content flex-shrink-0",
    onClick: onClose
  }));
}
export { HorizonBanner as default };
//# sourceMappingURL=index.js.map
